import { FreightDeliveryAccessorialPresetRowSchema } from "@redotech/redo-model/freight/freight-delivery-accessorial-preset";
import * as z from "zod";

export const createFreightDeliveryAccessorialPreset = {
  name: "createFreightDeliveryAccessorialPreset" as const,
  input: z.object({
    name: z.string(),
    liftgateRequired: z.boolean(),
    insideDelivery: z.boolean(),
    appointmentRequired: z.boolean(),
    instructions: z.string().nullish(),
  }),
  output: FreightDeliveryAccessorialPresetRowSchema,
};
